"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockSyndicationMatch = void 0;
const faker_1 = require("@faker-js/faker");
const createMockSyndicationMatch = (overwrites = {}) => {
    return Object.assign({ id: faker_1.faker.random.numeric(), companyId: faker_1.faker.random.numeric(), uuid: 'zzz-yyy-xxx-025', status: 'sent', companyActionStatus: 'sent', syndicationInvestorActionStatus: 'sent', syndicationInvestorId: 11, optOutOfFee: false, syndicationInvestor: {
            location: 'US',
            priority: 1,
            investmentTypes: {
                label: 'Equity',
                value: 'equity',
            },
            investmentRanges: {},
            investmentBusinessTypes: {},
        }, company: {
            id: faker_1.faker.random.numeric(),
            name: 'Dinoco 21',
            publicDescription: faker_1.faker.random.words(),
            businessType: null,
            application: {
                dataroomEnable: false,
                ebitdaBurn: 'between_minus_5_and_0_m',
                totalEquityRaised: 'between_0_and_5_m',
                existingDebt: 'between_10_and_25_m',
                fundraisingTimeFrame: null,
                insightsEnable: false,
                investmentAmount: 2300000,
                investmentTypes: null,
                latestPostMoneyValuation: null,
                location: null,
                margins: 'between_75_and_100_percentage',
                revenueModel: 'saas',
                targetDebtRaise: 'between_10_and_25_m',
                useOfFunds: 'Some use of found #2',
                industryVertical: 'commercial_finance',
                yearOverYearGrowthRate: 'between_0_and_25_percentage',
                yearlyRevenue: 'between_3_and_5_m',
            },
            contact: {
                position: null,
                email: null,
                firstName: null,
                lastName: null,
                phone: null,
            },
            country: null,
            description: faker_1.faker.random.words(),
            state: null,
            type: null,
            website: null,
            teaserData: {},
            tags: [],
        } }, overwrites);
};
exports.createMockSyndicationMatch = createMockSyndicationMatch;
//# sourceMappingURL=Match.js.map